// 로그인이 필요한 경로 접두사. App.js에서 <PrivateRoute>로 감싼 라우트와 일치해야
// 한다(세션 만료 시 access-토큰 기준 + 재로그인 모달을 띄울지 판단하는 단일 기준).
//
// 예외: /event/check-in/:pk. PrivateRoute로 감싸지만 일부러 여기 넣지 않는다.
// 재로그인 모달의 [로그인]은 /login으로 갈 때 from을 넘기지 않아(SessionWatcher
// handleLogin), 로그인 후 체크인 URL이 아니라 홈으로 떨어진다. 목록에서 빼면
// 만료 시 조용한 로그아웃 → PrivateRoute 리다이렉트 경로를 타므로 from이 보존되고
// 로그인 직후 체크인이 그대로 이어진다. 이 페이지엔 잃을 작업 상태도 없다.
export const PROTECTED_PREFIXES = ["/mypage", "/edit-profile"];

// 주어진 경로가 보호 경로인지 여부. 정확히 일치하거나 하위 경로(/mypage/...)면 true.
export function isProtectedPath(pathname) {
    return PROTECTED_PREFIXES.some(
        (p) => pathname === p || pathname.startsWith(p + "/")
    );
}
